<form [formGroup]="form" fxLayout="row" [fxLayoutGap]="LYT_GAP">
  <div [fxFlex]="COLS[0]" class="first-col" fxLayout="row" fxLayoutAlign="start center" [fxLayoutGap]="LYT_GAP">
    <redispatch-labeled-textbox [text]="rowDesc.description"
    [required]="rowDesc.required"></redispatch-labeled-textbox>
    <redispatch-erzeugungsanlage-form-prefix class="help-icon" [feld]="feldMapping?.kopplungsTyp"
    tooltipPosition="right"></redispatch-erzeugungsanlage-form-prefix>

    <mat-form-field class="hidden">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.kopplungsTyp"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <input matInput
        [redispatchDisableControl]="readonly || disabled"
        formControlName="kopplungsTyp">
    </mat-form-field>
  </div>

  <mat-form-field [fxFlex]="COLS[1]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.hohesByte"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      type="number"
      step="1"
      [placeholder]="placeholder"
      formControlName="hohesByte">
    @if (f.hohesByte.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.hohesByte.hasError('min')) {
      <mat-error>Wert zu klein</mat-error>
    }
    @if (f.hohesByte.hasError('max')) {
      <mat-error>Wert zu groß</mat-error>
    }
    @if (f.hohesByte.hasError('pattern') && !f.hohesByte.hasError('min')) {
      <mat-error>
        Es sind nur natürliche Zahlen erlaubt
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field [fxFlex]="COLS[2]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.mittleresByte"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      type="number"
      step="1"
      [placeholder]="placeholder"
      formControlName="mittleresByte">
    @if (f.mittleresByte.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.mittleresByte.hasError('min')) {
      <mat-error>Wert zu klein</mat-error>
    }
    @if (f.mittleresByte.hasError('max')) {
      <mat-error>Wert zu groß</mat-error>
    }
    @if (f.mittleresByte.hasError('pattern') && !f.mittleresByte.hasError('min')) {
      <mat-error>
        Es sind nur natürliche Zahlen erlaubt
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field [fxFlex]="COLS[3]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.niedrigesByte"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      type="number"
      step="1"
      [placeholder]="placeholder"
      formControlName="niedrigesByte">
    @if (f.niedrigesByte.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.niedrigesByte.hasError('min')) {
      <mat-error>Wert zu klein</mat-error>
    }
    @if (f.niedrigesByte.hasError('max')) {
      <mat-error>Wert zu groß</mat-error>
    }
    @if (f.niedrigesByte.hasError('pattern') && !f.niedrigesByte.hasError('min')) {
      <mat-error>
        Es sind nur natürliche Zahlen erlaubt
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field [fxFlex]="COLS[4]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.typkennung"
    [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      type="number"
      step="1"
      pattern="\d*"
      [placeholder]="placeholder"
      formControlName="typkennung">
    @if (f.typkennung.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.typkennung.hasError('pattern')) {
      <mat-error>Keine Ganzzahl</mat-error>
    }
    @if (f.typkennung.hasError('wrongTypkennung')) {
      <mat-error>
        Gültige Werte sind {{ typkennungValidValues }}
      </mat-error>
    }
  </mat-form-field>

  <div [fxFlex]="COLS[5]" fxLayoutAlign="center center">
    @if (!form.valid) {
      <mat-icon class="row-warn"
                aria-hidden="false"
                [attr.aria-label]="warningTooltip"
                [matTooltip]="warningTooltip"
      >
        warning
      </mat-icon>
    }
    @if (form.valid) {
      <mat-icon class="row-ok">check_circle</mat-icon>
    }
  </div>
</form>

